<template>
  <div>
    <p class="font-weight-bold">
      Enliste los materiales peligrosos que utilizará:
    </p>
    <div class="protocol-attachments-container">
      <div class="list-group list-group-bordered mb-3">
        <div class="list-group-header d-flex align-items-center">
          <span class="">{{ materials.length }} {{
              materials.length === 1
                ? 'Material'
                : 'Materiales'
                         }} {{ materials.length === 1 ? 'Agregado' : 'Agregados' }}</span>
          <div class="ml-auto">
            <div class="d-inline-block">
              <button class="btn btn-light" data-target="#dangerous-materials-modal" data-toggle="modal"
                      title="Add files" type="button">
                <i class="fas fa-plus-circle mr-2"></i> Agregar material
              </button>
            </div>
          </div>
        </div>
        <div v-if="materials && materials.length">
          <div v-for="(material, key) in materials"
               :key="key"
               class="list-group-item">
            <div class="list-group-item-figure">
              <a class="tile tile-circle bg-info" href="#">
                <i class="fas fa-virus"></i>
              </a>
            </div>
            <div class="list-group-item-body">
              <h4 class="list-group-item-title">
                {{ material.name }}
              </h4>
              <p class="list-group-item-text text-truncate">
                <b>Tipo de riesgo:</b>
                {{ material.risk_type }}
              </p>
              <p class="list-group-item-text text-truncate">
                <b>Escala de riesgo:</b>
                {{ material.risk_scale }}
              </p>
            </div>
            <div class="list-group-item-figure align-items-start">
              <div class="dropdown show">
                <button aria-expanded="true" class="btn btn-sm btn-icon btn-light"
                        data-toggle="dropdown">
                  <i class="fa fa-fw fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="dropdown-arrow mr-n1"></div>
                  <div class="dropdown-divider"></div>
                  <button class="dropdown-item"
                          type="button"
                          @click.prevent="editDangerousMaterial(key)">
                    Editar material
                  </button>
                  <button class="dropdown-item"
                          type="button"
                          @click.prevent="deleteDangerousMaterial(key)">
                    Eliminar material
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dangerous-materials-modal ref="dangerousMaterialsModal"
                               @add-dangerous-material="addDangerousMaterialToList"
                               @update-dangerous-material="updateDangerousMaterial"></dangerous-materials-modal>
  </div>
</template>

<script>
  import DangerousMaterialsModal from './DangerousMaterialsModal'
  import { AlertManager } from '../../../utils/AlertManager'
  
  export default {
    name: 'DangerousMaterialsList',
    components: {
      DangerousMaterialsModal,
    },
    props: {
      materials: {
        type: Array,
        default: () => ([]),
      },
    },
    data: () => ({}),
    methods: {
      addDangerousMaterialToList (material) {
        this.materials.push(material)
        
        $('#dangerous-materials-modal').modal('hide')
      },
      deleteDangerousMaterial (index) {
        this.materials.splice(index, 1)
        
        AlertManager.success('Material eliminado correctamente')
      },
      editDangerousMaterial (index) {
        this.$refs.dangerousMaterialsModal.editDangerousMaterial(index, this.materials[index])

        $('#dangerous-materials-modal').modal('show')
      },
      updateDangerousMaterial (index, material) {
        this.materials.splice(index, 1, material)

        $('#dangerous-materials-modal').modal('hide')
      }
    },
    mounted () {
    
    },
  }
</script>
